import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/** react-router doesn't reset scroll on navigation; this does. */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}
